<template lang="pug">
v-dialog(:value="value" :width="340" @input="updateValue")
  v-card
    v-card-title(data-test="c-accept-title") Accept
    v-card-text 
      filter-autocomplete(
        :getItems="getProductNames" 
        v-model="productName"
        item-text="name"
        item-value="name"
        label="Product name"
        data-test="c-accept-product"
        :error="formErrors.hasError('productName')"
        :error-messages="formErrors.fields.productName"
      ).mr-4.c-accept-product
      cbr-location-users(
        :model="model"
        v-slot="location"
      )
        cbr-user(
          :formErrors="formErrors" 
          v-model="cbrUser" 
          :product="selectedProduct"
          :formattedUsersList="location.list"
        ).data-test
      
    v-card-actions
      v-spacer
      v-btn(color="error" text @click="_failBtnClicked") Close
      v-btn(color="success" text @click="_okBtnClicked" data-test="c-accept-btn") Accept candidate
</template>

<script>
import {mapGetters, mapActions} from "vuex"
import FormErrors from "@/util/form-errors"
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    cbrUserDefault: Number,
    model: Object
  },

  data: () => ({
    cbrUser: null,
    productName: null,
    formErrors: new FormErrors()
  }),

  computed: {
    ...mapGetters({
      getProductBy: 'crmProductNames/getItemBy'
    }),
    selectedProduct() {
      if(!this.productName) return null
      return this.getProductBy({field: 'name', value: this.productName})
    }
  },

  mounted() {
    // this.setDefault()
  },
  methods: {
    ...mapActions({
      getCBRUser: 'cbrUser/list',
      getProductNames: 'crmProductNames/list'
    }),

    setDefault() {
      if(this.cbrUserDefault) this.cbrUser = this.cbrUserDefault
      this.productName = this.model.productName
    },

    _failBtnClicked() {
      this.updateValue(false)
    },

    updateValue: function (value) {
      this.$emit('input', value)
    },

    _okBtnClicked() {
      if(!this.isValid()) return
      this.$emit('okClicked', {сbrUser: this.cbrUser, productName: this.productName})
    },

    isValid() {
      if(!this.cbrUser || !this.productName) {
        this.$notify({text: 'Please, select all fields', type: 'error'})
        return false
      }
      return true
    }
  },

  watch: {
    value() {
      if(this.value) this.setDefault()
    },

    productName(newVal, oldVal) {
      if(!oldVal) return
      if(newVal.isExtended !== oldVal.isExtended) this.cbrUser = null
    }
  },
  
  components: {
    filterAutocomplete: () => import('@/components/global/FilterAutocomplete.vue'),
    cbrLocationUsers: () => import('./CandidatesCbrLocationUsers.vue'),
    cbrUser: () => import('./CandidateCbrUser.vue')
  }
}
</script>